import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SessionType } from "src/modules/interface";
import { keepUserSessionAlive } from "src/modules/session/init";

/**
 * Force-logs-out CBH admins after 24 hours of session lifetime when
 * `ADMIN_24H_SESSION_EXPIRY_ENABLED` is on. Workplace users keep the longer
 * default validity (`keepUserSessionAlive`'s 720-hour default).
 */
const useLogoutIn24Hours = () => {
  const { type, profile } = useSelector((state: SessionType) => state.session);
  const dispatch = useDispatch();
  const isAdmin24HoursSessionExpiryEnabled = useCbhFlag(
    CbhFeatureFlag.ADMIN_24H_SESSION_EXPIRY_ENABLED,
    { defaultValue: false }
  );

  useEffect(() => {
    const isAdmin = profile?.userId && type === "ADMIN";

    if (isAdmin && isAdmin24HoursSessionExpiryEnabled) {
      void keepUserSessionAlive(dispatch, 24);
    }
  }, [type, profile, dispatch, isAdmin24HoursSessionExpiryEnabled]);
};

export { useLogoutIn24Hours };
